var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5219 0.405044C19.6518 0.367385 19.7894 0.365531 19.9203 0.39968C20.0511 0.433828 20.1702 0.502708 20.2651 0.59903C20.36 0.695352 20.4271 0.815535 20.4593 0.946859C20.4915 1.07818 20.4875 1.21576 20.4479 1.34504L18.0159 9.25004H9.49994C9.30103 9.25004 9.11026 9.32906 8.96961 9.46972C8.82896 9.61037 8.74994 9.80113 8.74994 10C8.74994 10.199 8.82896 10.3897 8.96961 10.5304C9.11026 10.671 9.30103 10.75 9.49994 10.75H18.0159L20.4479 18.655C20.4875 18.7843 20.4915 18.9219 20.4593 19.0532C20.4271 19.1846 20.36 19.3047 20.2651 19.4011C20.1702 19.4974 20.0511 19.5663 19.9203 19.6004C19.7894 19.6346 19.6518 19.6327 19.5219 19.595C12.907 17.6714 6.66901 14.6324 1.07694 10.609C0.98031 10.5396 0.901594 10.4481 0.847298 10.3422C0.793001 10.2363 0.764685 10.119 0.764685 10C0.764685 9.88104 0.793001 9.76375 0.847298 9.65785C0.901594 9.55196 0.98031 9.4605 1.07694 9.39104C6.66899 5.36769 12.907 2.32869 19.5219 0.405044Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8063bb414662b734aa6b2393dfb34e72.svg";
export { ForwardRef as ReactComponent };